var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.167,
    height: 43.657,
    viewBox: "0 0 36.167 43.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location",
    d: "M20.833,45.491,8.046,32.7a18.083,18.083,0,1,1,25.574,0Zm9.946-15.628a14.065,14.065,0,1,0-19.892,0l9.946,9.946,9.946-9.946Zm-9.946-5.927a4.018,4.018,0,1,1,2.842-1.177A4.019,4.019,0,0,1,20.833,23.935Z",
    transform: "translate(-2.75 -1.833)",
    fill: "#ff6624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.73012523d321fbc6d62d9dfa06d87afe.svg";
export { ForwardRef as ReactComponent };